import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "../../types/commonElements";
import {
  modeOfPaymentOptions,
  paymentTypeOptions,
} from "../../config/constants/options";
import { FormData, ProcedureState } from "../../types/procedureType";

const initialState: ProcedureState = {
  formData: {
    procedureName: "",
    noOfSession: 1,
    totalAmount: "",
    amount: "",
    modeOfPayment: "",
    paymentReferenceNo: "",
    paymentType: "",
    focReason: "",
    paymentStatus: "",
    procedureStatus: "",
    isGstCollected: false,
    customerId: "",
  },
  errors: {},
  selectOptions: {
    paymentType: [paymentTypeOptions[0]],
    modeOfPayment: modeOfPaymentOptions,
    procedureName: [],
    paymentStatus: [],
    procedureStatus: [],
  },
  sessionRows: [],
  hasUnsavedChanges: false,
};

const procedureSlice = createSlice({
  name: "procedure",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormData & { skipUnsavedFlag?: boolean }>) => {
      state.formData = { ...state.formData, ...action.payload };
      // Set hasUnsavedChanges to true when form data is modified (unless skipUnsavedFlag is true)
      if (!action.payload.skipUnsavedFlag) {
        state.hasUnsavedChanges = true;
      }
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    setSessionRows: (state, action: PayloadAction<{ rows: any[]; skipUnsavedFlag?: boolean } | any[]>) => {
      // Handle both old format (array) and new format (object with rows and skipUnsavedFlag)
      if (Array.isArray(action.payload)) {
        state.sessionRows = action.payload;
        state.hasUnsavedChanges = true;
      } else {
        state.sessionRows = action.payload.rows;
        if (!action.payload.skipUnsavedFlag) {
          state.hasUnsavedChanges = true;
        }
      }
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
      state.sessionRows = [];
      state.hasUnsavedChanges = false;
    },
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
  setSessionRows,
  setHasUnsavedChanges,
} = procedureSlice.actions;

export default procedureSlice.reducer;
